import { render, staticRenderFns } from "./captain_id_type.vue?vue&type=template&id=1c1cf2fb&scoped=true&"
import script from "./captain_id_type.vue?vue&type=script&lang=js&"
export * from "./captain_id_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1cf2fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1cf2fb')) {
      api.createRecord('1c1cf2fb', component.options)
    } else {
      api.reload('1c1cf2fb', component.options)
    }
    module.hot.accept("./captain_id_type.vue?vue&type=template&id=1c1cf2fb&scoped=true&", function () {
      api.rerender('1c1cf2fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/captain_id_type.vue"
export default component.exports